export function AttendanceStatusBadge() {
  return <span className="status-badge status-checked_in">Checked in</span>;
}
